import { PixoPt, PixoSpatial, PixoSpatialCoord } from '../../model/Pixospatial';
import { DrawPaneComponent } from './draw-pane.component';
import * as d3 from 'd3';
import * as turf from '@turf/turf'
import { AnyHandler } from '../../types/@types/sl-v-types';
import { D3SelectedElement, D3SelectedGroup, EventMap, IDrawContext, IDrawer, IMapInteraction, MakeInteractionGroup, RemoveInteractionGroup } from './draw-pane-utils';
export class PolygonROI implements IMapInteraction, IDrawContext {
  public context: IDrawer;
  public enabled = false;
  public interactionGroup: D3SelectedGroup;
  public pixo: PixoSpatial;

  private drawRect: D3SelectedGroup;
  private eventMap: EventMap;
  private handler?: AnyHandler;
  public itemElement?: D3SelectedElement;
  private lastTime: number;
  private points: Array<PixoSpatialCoord>;
  private rubberGroup;
  private started = false;
  public get drawWidth() {
    return !!this.context ? this.context?.drawWidth : 0;
  }
  public get drawHeight() {
    return !!this.context ? this.context?.drawHeight : 0;
  }
  Enable(context: IDrawer, drawRect: D3SelectedGroup, handler: AnyHandler): void {
    if (this.enabled) return;
    this.context = context;
    this.handler = handler;
    this.enabled = true;
    this.drawRect = drawRect;
    this.lastTime = Number(new Date())
    this.points = [];
    this.pixo = this.context.spatialContext;
    this.started = false;
    this.eventMap = {
      touchStart: this.TouchStart.bind(this),
      touchMove: this.TouchMove.bind(this),
      touchEnd: this.TouchEnd.bind(this),
      mouseDown: this.MouseDown.bind(this),
      mouseMove: this.MouseMove.bind(this),
      mouseUp: this.MouseUp.bind(this)
    };
    this.interactionGroup = MakeInteractionGroup(this, drawRect, this.eventMap)
    this.itemElement = this.drawRect.append('polygon');
    this.itemElement!.attr('fill', 'blue')
      .attr('data-role', 'rubber-band-roi')
      .attr('stroke', 'black')
      .attr('stroke-width', 2)
      .attr('data-id', 'roi-polygon')
      .attr('filter', '#glow')
      .classed('roi-polygon', true);
    this.itemElement.on('mouseup',this.MouseUp.bind(this));
  }
  TouchStart(event) {
    const touches: TouchList = event.touches;
    if (!touches) return;
    if (!touches.item(0)) return;
    this.points = [];
    const rect: DOMRect = (this.drawRect.node() as SVGElement).getBoundingClientRect();
    const touchPt = this.pixo.PixoPt({
      x: ((touches.item(0) as Touch).pageX - rect.left),
      y: ((touches.item(0) as Touch).pageY - rect.top)
    });
    const touchCoord = this.pixo.PixoSpatialCoord(touchPt);
    this.points.push(touchCoord)
    this.started = true;
    this.UpdatePolygon();
  }
  TouchMove(event) {
    if (!this.started) return;
    const touches: TouchList = event.event.changedTouches;
    if (!touches) return;
    if (!touches.item(0)) return;
    const rect: DOMRect = (this.drawRect.node() as SVGElement).getBoundingClientRect();
    const touchPt = this.pixo.PixoPt({
      x: ((touches.item(0) as Touch).pageX - rect.left),
      y: ((touches.item(0) as Touch).pageY - rect.top)
    });
    const touchCoord = this.pixo.PixoSpatialCoord(touchPt);
    this.points.push(touchCoord)
    this.UpdatePolygon();

  }
  TouchEnd(_event) {
    if (this.handler) {
      this.handler(this.ToTurf());
    }
    this.points.splice(0);
    this.Disable();
  }
  MouseDown(event) {
    if (!this.enabled) return;
    this.points = [];
    const x = d3.event.layerX;
    const y = d3.event.layerY;
    const coord = this.pixo.PixoSpatialCoord(this.pixo.PixoPt({ x: x, y: y }));
    this.points.push(coord)
    this.started = true;
    this.UpdatePolygon();
  }
  MouseMove(_event) {
    if (!this.started) return;
    if (this.enabled && (Number(new Date()) - this.lastTime) > 100) {
      const x = d3.event.layerX;
      const y = d3.event.layerY;
      const coord = this.pixo.PixoSpatialCoord(this.pixo.PixoPt({ x: x, y: y }));
      this.points.push(coord);
      this.UpdatePolygon();
      this.lastTime = Number(new Date())
    }
  }
  MouseUp(_event) {
    this.started = false;
    if(!this.enabled) return;
    try {
      if (this.handler) {
        this.handler(this.ToTurf());
      }

    } finally {
    }
    this.Disable();

  }

  Disable() {
    if(!this.enabled) return;
    this.started = false;
    this.itemElement?.remove();
    delete this.itemElement;
    delete this.handler;
    this.enabled = false;
    RemoveInteractionGroup(this.interactionGroup, this.eventMap);

  }
  TogglePausing(paused: boolean) {
    this.enabled = (paused) ? false : !!this.interactionGroup;
  }
  UpdatePolygon() {
    const pointsString = this.points.map(p => `${p.pixo.x},${p.pixo.y}`).join(' ');
    this.itemElement?.attr("points", pointsString);
  }
  ToTurf() {
    const lngLatPoints = [];
    for (const pt of this.points) {
      lngLatPoints.push([pt.spatial.lng, pt.spatial.lat]);
    }
    if (lngLatPoints.length > 0) lngLatPoints.push(lngLatPoints[0]);
    if (lngLatPoints.length < 4) return undefined;
    const turfPoly = turf.polygon([lngLatPoints]);
    return turfPoly;
  }
}
